const getFileSide = fileName => (/rh/.test(fileName) && 'right') || (/lh/.test(fileName) && 'left') || '';
export default getFileSide;